import React, { useState } from "react";
import { Download, X, Share } from "lucide-react";
import { useI18n } from "../i18n";
import { useInstall } from "../context/InstallContext";

export default function InstallButton({ compact }) {
  const { t } = useI18n();
  const { canInstall, hasPrompt, isIOS, install } = useInstall();
  const [showIos, setShowIos] = useState(false);

  if (!canInstall) return null;

  const onClick = async () => {
    if (hasPrompt) { await install(); return; }
    if (isIOS) setShowIos(true);
  };

  return (
    <>
      <button onClick={onClick} data-testid="install-app-btn"
        className={`inline-flex items-center gap-2 rounded-full font-semibold transition-all hover:scale-[1.03] ${compact ? "bg-[#112240] border border-amber-500/40 text-amber-300 text-sm px-3 py-2" : "bg-teal-600 hover:bg-teal-500 text-white text-sm px-4 py-2"}`}>
        <Download className="h-4 w-4" /> {t.common.install}
      </button>

      {showIos && (
        <div className="fixed inset-0 z-[90] bg-black/70 flex items-end sm:items-center justify-center p-4" onClick={() => setShowIos(false)} data-testid="ios-install-modal">
          <div className="bg-[#112240] border border-amber-500/30 rounded-2xl p-6 max-w-sm w-full" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-display text-lg text-amber-400">{t.common.install}</h3>
              <button onClick={() => setShowIos(false)} className="text-slate-400"><X className="h-5 w-5" /></button>
            </div>
            <p className="text-slate-300 text-sm leading-relaxed flex items-center gap-2"><Share className="h-5 w-5 text-teal-400 shrink-0" /> {t.common.iosInstall}</p>
          </div>
        </div>
      )}
    </>
  );
}
